import { useEffect, useState } from 'react';

const TYPE_MS = 45;
const ERASE_MS = 20;
const HOLD_MS = 2000;

/**
 * Types each text in turn, holds it, erases it, then moves to the next: a
 * placeholder that shows what can be asked. Off (returns `fallback`) while
 * `enabled` is false or the user asks for reduced motion.
 */
export default function useTypingPlaceholder(texts, fallback, enabled = true) {
  const [shown, setShown] = useState('');
  const still =
    !enabled ||
    texts.length === 0 ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const key = texts.join('\n');

  useEffect(() => {
    if (still) return undefined;
    let index = 0;
    let length = 0;
    let erasing = false;
    let timer;
    const tick = () => {
      const text = texts[index];
      if (!erasing && length < text.length) {
        length += 1;
        timer = setTimeout(tick, TYPE_MS);
      } else if (!erasing) {
        erasing = true;
        timer = setTimeout(tick, HOLD_MS);
      } else if (length > 0) {
        length -= 1;
        timer = setTimeout(tick, ERASE_MS);
      } else {
        erasing = false;
        index = (index + 1) % texts.length;
        timer = setTimeout(tick, TYPE_MS);
      }
      setShown(texts[index].slice(0, length));
    };
    timer = setTimeout(tick, TYPE_MS);
    return () => clearTimeout(timer);
    // `key` stands for `texts`, a new array on each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, still]);

  return still ? fallback : shown || fallback;
}
